import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageSelector.css';

const LOCALE_LABELS = {
  en: 'English',
  hi: 'हिंदी',
  pa: 'ਪੰਜਾਬੀ',
  ta: 'தமிழ்',
  ml: 'മലയാളം'
};

const LanguageSelector = () => {
  const { locale, setLocale, supportedLocales } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="language-selector" ref={ref}>
      <button
        type="button"
        className={`language-selector__trigger ${locale !== 'en' ? 'language-selector__trigger--local' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-label="Select language"
      >
        <span className="language-selector__label">{LOCALE_LABELS[locale] || 'English'}</span>
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" className={`language-selector__chevron ${isOpen ? 'open' : ''}`}>
          <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      {isOpen && (
        <ul
          className="language-selector__dropdown"
          role="listbox"
          aria-label="Language options"
        >
          {supportedLocales.map((code) => (
            <li key={code} role="option" aria-selected={locale === code}>
              <button
                type="button"
                className={`language-selector__option ${locale === code ? 'active' : ''} ${code !== 'en' ? 'language-selector__option--local' : ''}`}
                onClick={() => {
                  setLocale(code);
                  setIsOpen(false);
                }}
              >
                {LOCALE_LABELS[code]}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default React.memo(LanguageSelector);
